import React from 'react';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';

export const ButtonComponent = ({ onClick, title }) => (
  <NavigationButton.Primary
    labelText={title}
    onClick={e => {
      e.preventDefault();
      onClick();
    }}
  />
);
